import { createContext } from 'react'

const KanbanFiltersContext = createContext()

export default KanbanFiltersContext
